export const NAV_MOBILE_BREAKPOINT = 1310;
export const NAV_MOBILE_BREAKPOINT_WITH_FAVOURITES = 1400;
export const NAV_MOBILE_BREAKPOINT = 1310;
export const NAV_MOBILE_BREAKPOINT_WITH_FAVOURITES = 1400;
